module.exports = __webpack_public_path__ + "img/kt.9e556647.png";